import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { AFRICA_COUNTRIES, LIFESTYLE } from "@/data/products";
import { ArrowRight } from "lucide-react";
import WorldMap from "@/components/WorldMap";
import { useTranslation } from "react-i18next";

export default function ExportMap() {
  const { t } = useTranslation();
  return (
    <section className="py-24 lg:py-32 bg-neutral-950 text-white relative overflow-hidden" data-testid="export-map-section">
      <div className="absolute inset-0 opacity-15">
        <img src={LIFESTYLE.world} alt="World" className="w-full h-full object-cover" />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-neutral-950 via-neutral-950/70 to-neutral-950" />

      <div className="relative max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-12 gap-12 items-start mb-10">
          <div className="lg:col-span-5 space-y-6">
            <div className="eyebrow text-gold-400">Export Excellence</div>
            <h2 className="font-display font-bold text-4xl lg:text-5xl tracking-tighter leading-tight">
              Manchester made.<br />
              <span className="gold-gradient-text">Africa proud.</span>
            </h2>
            <p className="text-neutral-300 leading-relaxed">
              We work with distributors, supermarkets, hotels, restaurants, government supply, NGOs, schools, hospitals, airlines and shipping partners to bring SBC brands to every corner of Africa &mdash; and beyond.
            </p>
            <Link to="/export-africa" className="inline-flex items-center gap-2 bg-gold-400 hover:bg-gold-300 text-neutral-950 rounded-full px-6 py-3 text-sm font-semibold transition-colors" data-testid="export-cta">
              Explore Export Programme <ArrowRight className="w-4 h-4" />
            </Link>
          </div>

          <div className="lg:col-span-7">
            <div className="bg-white rounded-3xl p-6 shadow-2xl">
              <WorldMap compact />
            </div>
          </div>
        </div>

        <div className="bg-neutral-900/60 backdrop-blur border border-white/10 rounded-3xl p-8">
          <div className="text-xs uppercase tracking-widest text-neutral-400 mb-6">Target Markets</div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3">
            {AFRICA_COUNTRIES.map((c, i) => (
              <motion.div
                key={c}
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.03 }}
                className="flex items-center gap-2 text-sm"
              >
                <span className="w-1.5 h-1.5 rounded-full bg-gold-400" />
                {c}
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
